// BlockRenderer.tsx
import React from "react";
import ComponentErrorBoundary from "@danishagro/shared/src/components/molecules/ErrorBoundary/ComponentErrorBoundary.component";
import { useBlockDataMapping } from "@danishagro/sharedShop/src/hooks/useBlockDataMapping.hook";
import { BlockRendererProps } from "@interfaces/blockData.interface";
import { BLOCK_MAP } from "./blocksMap.helper";

const BlockRenderer = ({ block }: BlockRendererProps) => {
    // Cast block to any when checking for a 'content' property
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dataForMapping = (block as any).content
        ? block
        : { ...block, content: { props: block.props } };

    const baseMappedProps = useBlockDataMapping(block.alias, dataForMapping);
    const mappedProps = baseMappedProps;

    const Component = BLOCK_MAP[block.alias as keyof typeof BLOCK_MAP];

    if (!Component) return null;

    return (
        <ComponentErrorBoundary key={block.key} componentName={block.alias}>
            <Component alias={block.alias} {...mappedProps} version={block.version} />
        </ComponentErrorBoundary>
    );
};

export default BlockRenderer;
